import React from 'react';

const ToggleRow = ({ label, description, checked, onToggle, bordered }) => (
  <div className={`flex items-center justify-between ${bordered ? 'border-t pt-4' : ''}`}>
    <div>
      <p className="font-medium text-sm">{label}</p>
      {description && <p className="text-xs text-gray-400 mt-0.5">{description}</p>}
    </div>
    <div
      onClick={onToggle}
      className={`relative w-12 h-6 rounded-full cursor-pointer transition-colors flex-shrink-0 ${checked ? 'bg-blue-600' : 'bg-gray-300'}`}>
      <div className={`absolute top-1 w-4 h-4 bg-white rounded-full shadow transition-all duration-200 ${checked ? 'left-6' : 'left-1'}`} />
    </div>
  </div>
);

export default ToggleRow;